import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Atom — three intersecting elliptical orbits at 0°, 60°, 120°
 *  rotations around the centre, with a filled nucleus. Reads as
 *  "physics / sciences" at any size; pairs naturally with the math
 *  cluster in the taxonomy picker. */
export function IcnAtom(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="atom">
      <g style={{ transformOrigin: '8px 8px' }}>
        <ellipse cx="8" cy="8" rx="6" ry="2.4" />
        <ellipse cx="8" cy="8" rx="6" ry="2.4" transform="rotate(60 8 8)" />
        <ellipse cx="8" cy="8" rx="6" ry="2.4" transform="rotate(120 8 8)" />
      </g>
      <circle cx="8" cy="8" r="1.1" fill="currentColor" stroke="none" />
    </Svg>
  );
}
